import React from 'react';
import { useParams } from 'react-router-dom';
import { UserContext } from '@/components/App';
import Tariff from '@/components/Account/Tariffs';
import { useShipperScope } from './hooks';
import ShipperGate from './ShipperGate';

/** The tariff editor, run as the shipper so its ownership check and lookups use the shipper's account. */
const ShipperTariff = () => {
    const { client_id } = useParams();
    const { isPermitted, shipper, loading, error, shipperContext } = useShipperScope(client_id);

    if (!isPermitted || loading || !shipper) {
        return <ShipperGate isPermitted={isPermitted} loading={loading} error={error} shipper={shipper} />;
    }

    return (
        <UserContext.Provider value={shipperContext}>
            <Tariff />
        </UserContext.Provider>
    );
};

export default ShipperTariff;
